jQuery("#ywcnp_form_name_your_price").append("<span id='singleProdukt_error_success'></span>");

var ErrorSuccess = jQuery("#singleProdukt_error_success");

var inputNamePrice = jQuery("#ywcnp_form_name_your_price input");

var orderBTN = jQuery("#ywcnp_form_name_your_price + div + .single_add_to_cart_button");
orderBTN.prop("disabled", true)

var quantityElement = jQuery("#ywcnp_form_name_your_price + .quantity");
quantityElement.hide();


inputNamePrice.keypress(function(event){
    console.log(event.which);
if(event.which != 8 && isNaN(String.fromCharCode(event.which))){
    event.preventDefault();
}
else{
    ErrorSuccess.removeClass("error_quantity").addClass("success_quantity");
        if(jQuery(this).val() < 10 || jQuery(this).val() === ""){
            ErrorSuccess.addClass("error_quantity").removeClass("success_quantity");
            ErrorSuccess.text("mindeswert sind 10.00€");
            quantityElement.hide();
            orderBTN.prop("disabled", true)
        }
        else{
            ErrorSuccess.addClass("success_quantity");
            ErrorSuccess.text("Wie viel Gutscheine möchten sie?");
            quantityElement.show();
            orderBTN.prop("disabled", false)
        }
}

});

inputNamePrice.keyup(function(event){
        ErrorSuccess.removeClass("error_quantity").addClass("success_quantity");
        if(jQuery(this).val() < 10 || jQuery(this).val() === ""){
            ErrorSuccess.addClass("error_quantity").removeClass("success_quantity");
            ErrorSuccess.text("mindeswert sind 10.00€");
            quantityElement.hide();
            orderBTN.prop("disabled", true);
        }
        else{
            ErrorSuccess.addClass("success_quantity");
            ErrorSuccess.text("Wie viel Gutscheine möchten sie?");
            quantityElement.show();
            orderBTN.prop("disabled", false);
        }

});



